var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.svgList),function(item){return _c('mrc_ess_svgIcon',{key:item,attrs:{"icon-class":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }